<template>
    <div>
        <v-server-table ref="licenseTable" url="/subcontractors/licenses-list" :columns="columns" :options="options">

            <router-link slot="license_id" slot-scope="props" :to="`/subcontractors/settings/licenses/edit/${props.row.license_id}`" title="Edit License" class="btn btn-xs btn-default">
                <i class="fa fa-edit"></i> Edit
            </router-link>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['license_id', 'license_name'],
                options: {
                    perPage: 10000,
                    perPageValues: [],
                    columnsDropdown: false,
                    filterable: false,
                    headings: {
                        license_id: 'Edit',
                        license_name: 'License Name',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'licenses.license_name',
                    },
                    uniqueKey: 'license_id',
                },
            }
        }
    }
</script>
